import axios from "@/api/axios";

function list(params) {
  return axios.get("appeals/v1.0/personal_account_appeals/", { params });
}

function create({ data, username, headers = {} }) {
  return axios.post(`appeals/v1.0/personal_account_appeals/?username=${username}`, data, { headers });
}

function update({ id, data, username, headers = {} }) {
  return axios.patch(`appeals/v1.0/personal_account_appeals/${id}/?username=${username}`, data, { headers });
}

function appeal({ id, username, headers = {} }) {
  const params = { username };
  return axios.get(`appeals/v1.0/personal_account_appeals/${id}/`, { params, headers });
}

function appealEvents({ appealId, username, headers = {} }) {
  const params = { username };
  return axios.get(`appeals/v1.0/personal_account_appeals/${appealId}/events/?ordering=created_at`, { params, headers });
}

function uploadFile({ data, username, headers = {} }) {
  return axios.post(`appeals/v1.0/personal_account_appeals/attachments/?username=${username}`, data, {headers});
}

export default {
  list,
  create,
  update,
  appeal,
  appealEvents,
  uploadFile
};
